import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import BlankState from '../../../../components/BlankState';
import StatusMessages2 from '../../../../components/StatusMessages2';

import { saveCorporateUser, updateCorporateUser, listCorporates } from '../../../../actions/openCovers';

class AddCorporateUser extends Component{

    constructor(props){
        super(props);

        this.state = {
            corporate: {
                is_active: 'True'
            },
            updatedCorporate: {}
        };
    }

    componentDidMount(){
        this.props.listCorporates();
    }

    componentWillReceiveProps(nextProps){
        const corporate = nextProps.editCorporate || {};
        
        this.setState({
            corporate,
            updatedCorporate: {
                id: corporate ? corporate.id : ''
            }
        });
    }

    onChange = (e) =>{
        e.preventDefault();
        const { name, value } = e.target;
        const { corporate, updatedCorporate } = this.state;

        this.setState({
            corporate: {
                ...corporate,
                [name]: value
            },
            updatedCorporate: {
                ...updatedCorporate,
                [name]: value
            }
        });
    }

    onSubmit = (e) => {
        e.preventDefault();
        const { corporate, updatedCorporate } = this.state;

        const {

            company,
            first_name, 
            last_name,
            other_names,
            username,
            email, 
            phone,
            postal_address,
            is_active,
            
        } = corporate;
        
        let corporateUser = {
            user: {
                first_name, last_name, other_names, username, email, phone, postal_address, is_active
            },
            profile: { 
                company
            },
            type: "corporate_agent"
        };


        if(!corporateUser.hasOwnProperty('id')){
            
            this.props.saveCorporateUser(corporateUser);
        }else {
            corporateUser.user.id = updatedCorporate.id;
            this.props.updateCorporateUser(corporateUser);
        }
    }

    render(){
        const { corporate } = this.state;
        const { covers } = this.props;

        return(
            <form 
                className="form-horizontal" 
                onSubmit={ this.onSubmit }>

                <div className="col-sm-offset-4 col-sm-8">
                {
                    covers.createCorporateLoading ?

                        <BlankState 
                            data={ false }
                            customMessage="Saving details..."
                            isDataLoading={ covers.createCorporateLoading } />
                    :
                        <div>
                        {
                            covers.errorMessageCreateCorporate ?
                                
                                <StatusMessages2 
                                    type="error"
                                    message={ 
                                        covers.errorMessageCreateCorporate !== undefined ? 
                                            covers.errorMessageCreateCorporate
                                        : '' 
                                    } />
                            : null
                        }
                        {   
                            covers.successCreateCorporate ?
                                <StatusMessages2 
                                    type="success" 
                                    message="Details saved" />
                            : null
                        }
                        </div>
                }
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Company:
                        <span className="text-danger">*</span>
                    </label>
                    <div className="col-sm-8">
                        <select 
                            className="form-control"
                            name="company"
                            onChange={ this.onChange }
                            required
                            value={ corporate.company || '' }>

                            <option value="">Select a Company</option>
                            {
                                covers.companies.map((company, index)=>{
                                    return(
                                        <option key={ index } value={ company.id }>
                                            { company.name }
                                        </option>
                                    )
                                })
                            }
                        </select>
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">First Name:
                        <span className="text-danger">*</span>
                    </label>
                    <div className="col-sm-8">
                        <input 
                            type="text" 
                            name="first_name" 
                            className="form-control" 
                            onChange={ this.onChange } 
                            value={ corporate.first_name || '' }
                            required />
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Last Name:
                        <span className="text-danger">*</span>
                    </label>
                    <div className="col-sm-8">
                        <input 
                            type="text" 
                            name="last_name" 
                            className="form-control" 
                            onChange={ this.onChange } 
                            value={ corporate.last_name || '' }
                            required />
                    </div>
                </div>

                <div className="form-group hidden">
                    <label className="col-sm-4 control-label">Other Names:</label>
                    <div className="col-sm-8">
                        <input 
                            type="text" 
                            className="form-control"
                            onChange={ this.onChange } 
                            value={ corporate.other_names || '' } />
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Username:
                        <span className="text-danger">*</span>
                    </label>
                    <div className="col-sm-8">
                        <input 
                            type="text" 
                            name="username" 
                            className="form-control" 
                            onChange={ this.onChange } 
                            value={ corporate.username || '' }
                            required />
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Email:
                        <span className="text-danger">*</span>
                    </label>
                    <div className="col-sm-8">
                        <input 
                            type="email" 
                            name="email" 
                            className="form-control" 
                            onChange={ this.onChange } 
                            value={ corporate.email || '' }
                            required />
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Phone Number:
                        <span className="text-danger">*</span>
                    </label>
                    <div className="col-sm-8">
                        <input 
                            type="number"
                            min="0"
                            name="phone" 
                            className="form-control" 
                            onChange={ this.onChange } 
                            value={ corporate.phone || '' }
                            required />
                    </div>
                </div>

                <div className="form-group">
                    <label className="col-sm-4 control-label">Postal Address:
                        <span className="text-danger">*</span>
                    </label>
                    <div className="col-sm-8">
                        <input 
                            type="text" 
                            name="postal_address" 
                            className="form-control" 
                            onChange={ this.onChange } 
                            value={ corporate.postal_address || '' }
                            required />
                    </div>
                </div>

                <div className="form-group">
                    <div className="col-sm-8 col-sm-offset-4">
                    {
                        corporate.hasOwnProperty('id') ? 
                            <button type="submit" className="btn btn-warning">
                                <i className="icon ion-checkmark"></i> Edit Corporate User
                            </button>
                        :
                            <button type="submit" className="btn btn-success">
                                <i className="icon ion-checkmark"></i> Create Corporate User
                            </button>
                    }
                    </div>
                </div>
            </form>
        );
    }
}
const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    covers: state.covers
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ saveCorporateUser, updateCorporateUser, listCorporates }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(AddCorporateUser);



// WEBPACK FOOTER //
// ./src/pages/dashboard/policies/open-covers/AddCorporateUser.jsx